export default "__VITE_ASSET__6u_w6gYx__"